import * as React from 'react';
import { setRef } from '../../utils/setRef';

/**
 * Хук для создания ref-функции которая будет обрабатывать два ref
 *
 * @export
 * @template T
 * @param {...TUseForkRefArgs<T>} refs
 * @returns
 */
export function useForkRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  /**
   * useMemo нужен потому что React
   * при смене ref вызывает старый ref со значением null
   */
  return React.useMemo(function () {
    var validRefs = refs.filter(function (ref) {
      return !!ref;
    });

    if (!validRefs.length) {
      return null;
    }

    return function (value) {
      validRefs.forEach(function (ref) {
        setRef(ref, value);
      });
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [].concat(refs));
}